import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import {
    IPartIdentificationFormSection
} from '../../interfaces';


export const PartIdentificationFormSection: React.SFC<IPartIdentificationFormSection> = ({
    material,
    onUpdate,
    isContract,
    ...props
}: IPartIdentificationFormSection) => {

    useEffect(() => {

    }, [material])


    const isPartIdRequired = () => {

        if (!isContract) return false;


        //If any part id field is has a value

        let fullId = (material.partNumber ?? "") + (material.catalogueNumber ?? "") + (material.manufacturerNumber ?? "");
        if (fullId.length === 0)
            return true;

        else return false;
    }


    return (
        <Accordion defaultExpanded={true}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <DialogContentText color="primary">
                    Part Identification
                </DialogContentText>
            </AccordionSummary>
            <AccordionDetails>
                {isContract &&
                    <Typography variant="subtitle2" color="GrayText">
                        You must enter at least one form of part identification from the following 3 options.
                    </Typography>
                }

                <Grid container>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Part Number"
                            value={material.partNumber}
                            onChange={(e) => onUpdate("partNumber", e.currentTarget.value)}
                            required={isPartIdRequired()}

                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            inputProps={{ pattern: '^([0-9a-zA-Z]){3}/([0-9a-zA-Z]){6}$' }}
                            variant="outlined"
                            label="Catalogue Number"
                            value={material.catalogueNumber}
                            onChange={(e) => onUpdate("catalogueNumber", //automatically add the '/' to help with formatting
                                (e.currentTarget.value.length === 3 && !material.catalogueNumber?.includes("/")) ?
                                    (e.currentTarget.value + "/")
                                    : e.currentTarget.value)
                            }
                            required={isPartIdRequired()}
                            placeholder="XXX/XXXXXX"
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Manufacturer Number"
                            value={material.manufacturerNumber}
                            onChange={(e) => onUpdate("manufacturerNumber", e.currentTarget.value)}
                            required={isPartIdRequired()}


                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ mt: 2 }}>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Serial Number"
                            value={material.serialNumber}
                            onChange={(e) => onUpdate("serialNumber", e.currentTarget.value)}
                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>

                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Vehicle Number"
                            inputProps={{ maxLength: 5, minLength: 5 }}
                            placeholder="XXXXX"
                            value={material.vehicleNumber}
                            onChange={(e) => onUpdate("vehicleNumber", e.currentTarget.value)}

                        />
                    </Grid>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>

                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Unit Number"
                            inputProps={{ maxLength: 6, minLength: 6 }}
                            placeholder="XXXXXX"
                            value={material.unitNumber}
                            onChange={(e) => onUpdate("unitNumber", e.currentTarget.value)}
                        />
                    </Grid>
                </Grid>

                <Grid container sx={{ mt: 2 }}>
                    <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Porterbrook Asset Number"
                            value={material.porterbrookAssetNumber}
                            onChange={(e) => onUpdate("porterbrookAssetNumber", e.currentTarget.value)}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}